import { render, staticRenderFns } from "./CurrentCases.vue?vue&type=template&id=2d401a46&scoped=true&"
import script from "./CurrentCases.vue?vue&type=script&lang=js&"
export * from "./CurrentCases.vue?vue&type=script&lang=js&"
import style0 from "./CurrentCases.vue?vue&type=style&index=0&id=2d401a46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d401a46",
  null
  
)

export default component.exports